 import React from 'react'
import KbSetupComponent from './kbSetup.component'
 
 const KbSetupContainer = () => {
   return (
     <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
       <KbSetupComponent />
     </div>
   )
 }
 
 export default KbSetupContainer
 